<div class="flex min-w-0 flex-1 flex-col">
  <!-- Slot for things like breadcrumbs -->
  <ng-content select="[before-table]"></ng-content>

  <div class="flex-1">
    <aura-data-table
      matSort
      [inputColumns]="columns()"
      [filters]="filters()"
      [items]="items()"
      [count]="count()"
      [loading]="isLoading()"
      [pagination]="pagination()"
      [topButtons]="topButtons()"
      [itemActions]="itemActions()"
      [mappedFilters]="mappedFilters()"
      [hideSearch]="true"
      (removeFilter)="removeFilter()?.($event)"
      (clearFiltering)="clearFiltering()?.()"
      (triggerRefresh)="triggerRefresh()?.()"
      (triggerFiltering)="triggerFiltering()?.()"
      (filterViewChanged)="filterViewChanged()?.($event)"
      (itemClicked)="itemClicked()?.($event)"
      (pageChanged)="pageChanged()?.($event)"
      (searchChanged)="searchChanged()?.($event)"
      (matSortChange)="sortChanged()?.($event)"
    >
      <ng-template #filterTemplate>
        <core-transactions-data-table-filter
          [dto]="appliedFilter()"
          [filters]="filters()"
          [currentFilterView]="currentFilterView()"
          (filterChanged)="filterChanged()?.($event)"
        />
      </ng-template>

      @for (column of columns(); track $index) {
        @if (!column.native) {
          <ng-container [matColumnDef]="column.key">
            <th
              mat-header-cell
              *matHeaderCellDef
              mat-sort-header
              [sortActionDescription]="'Trier par ' + column.label | lowercase"
              class="font-bold text-primary"
            >
              {{ column.label }}
            </th>
            @switch (column.key) {
              @case ('user') {
                <td mat-cell *matCellDef="let tx">
                  @if (tx.user) {
                    <button
                      [matTooltip]="'Utilisateur'"
                      [routerLink]="['/users', tx.user._id]"
                      mat-button
                      class="link flex flex-row items-center"
                    >
                      <aura-avatar
                        [label]="$safeNavigationMigration(tx.user.identity?.firstName)"
                        [srcImage]="$safeNavigationMigration(tx.user.identity?.avatar?.url)"
                        [size]="'xs'"
                      />

                      <div class="ml-2">
                        {{ $safeNavigationMigration(tx.user.identity?.firstName) | titlecase }}
                        {{ $safeNavigationMigration(tx.user.identity?.lastName) | titlecase }}
                      </div>
                    </button>
                  }
                </td>
              }
              @case ('subscription') {
                <td mat-cell *matCellDef="let tx">
                  @if (tx.subscription) {
                    <button
                      [matTooltip]="'Voir l\'abonnement'"
                      [routerLink]="['/subscriptions', tx.subscription._id]"
                      mat-button
                      class="link"
                    >
                      @if (tx.subscription.plan) {
                        {{ tx.subscription.plan.name }}
                      } @else {
                        Abonnement #{{ tx.subscription._id | slice: -6 }}
                      }
                    </button>
                  }
                </td>
              }
              @case ('amount') {
                <td mat-cell *matCellDef="let tx">
                  <span class="font-semibold text-gray-12">
                    {{ tx.amount | priceDisplay: tx.currency }}
                  </span>
                </td>
              }
              @case ('status') {
                <td mat-cell *matCellDef="let tx">
                  <div
                    class="inline-flex items-center gap-x-1.5 rounded-md bg-neutral-a4 px-1.5 py-0.5 text-sm font-medium"
                  >
                    <div
                      class="size-1.5 rounded-full"
                      [class.bg-green-9]="tx.status === 'succeeded'"
                      [class.bg-amber-9]="tx.status === 'pending'"
                      [class.bg-red-9]="tx.status === 'failed'"
                      [class.bg-neutral-9]="tx.status === 'requires_action'"
                    ></div>
                    {{ tx.status | transactionStatusDisplay }}
                  </div>
                </td>
              }
              @case ('date') {
                <td mat-cell *matCellDef="let tx">
                  {{ tx.date | luxonDate: 'dd/LL/yyyy HH:mm' }}
                </td>
              }
              @case ('createdAt') {
                <td mat-cell *matCellDef="let tx">
                  {{ tx.createdAt | luxonDate: 'humanize' }}
                </td>
              }
              @default {
                <td mat-cell *matCellDef="let tx">
                  {{ tx[column.key] }}
                </td>
              }
            }
          </ng-container>
        }
      }
    </aura-data-table>
  </div>
</div>
